import type { Theme } from '@mui/material';

import { brandBackground } from 'src/theme/brandBackground';

export const styles = {
  notification: (theme: Theme) => ({
    bgcolor: theme.colors.secondary[50],
    position: 'absolute',
    zIndex: 11,
    lineHeight: '10px',
    px: 0.25,
    borderRadius: '2px',
    borderBottomRightRadius: 0,
    top: '-7px',
    left: '-20px',

    [theme.breakpoints.up('sm')]: {
      top: 0,
      left: 0,
    },

    svg: {
      height: '17px',
    },
  }),

  button: (theme: Theme) => ({
    padding: 0,
    height: '35px',
    width: '35px',

    [theme.breakpoints.up('sm')]: {
      height: '2.5rem',
      width: '2.5rem',
      transition: 'height 0.3s ease-in-out, width 0.3s ease-in-out',
      ':hover': {
        height: '5rem',
        width: '5rem',
      },
    },

    svg: {
      height: '100%',
      width: '100%',
    },
  }),

  dialog: (theme: Theme) => ({
    '.MuiPaper-root': {
      overflow: 'hidden',
      p: 0.5,
      background: brandBackground(theme),
      height: '100%',
      maxHeight: '100%',
      width: '100%',
      maxWidth: '100%',
      m: 0,

      [theme.breakpoints.up('sm')]: {
        position: 'absolute',
        height: 'unset',
        width: '600px',
        top: '220px',
        right: '48px',
        bottom: '18px',
      },
    },
  }),

  header: (theme: Theme) => ({
    background: brandBackground(theme),
    px: 4,
    py: [3.5, 2.825],
  }),

  headerIcon: {
    flexGrow: 0,
    width: '42px',
    height: '42px',

    svg: {
      height: '100%',
      width: '100%',
    },
  },

  overline: (theme: Theme) => ({
    ...theme.typography.h4,
    color: theme.colors.secondary[800],
  }),

  subline: (theme: Theme) => ({
    ...theme.typography.body4,
    color: theme.colors.secondary[700],
  }),

  paperWrapper: (theme: Theme) => ({
    height: '100%',
    overflow: 'hidden',
    bgcolor: theme.colors.white,
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',

    '.MuiDialogContent-root': {
      height: '100%',
      overflow: 'hidden',
    },
  }),
};
